var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditDocumentUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -15,
    y: -15,
    width: 60,
    height: 60
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(7.5px)",
      clipPath: "url(#bgblur_0_17620_34989_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 15
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6.0003C20.2626 5.73766 20.5744 5.52932 20.9176 5.38718C21.2608 5.24503 21.6286 5.17188 22 5.17188C22.3714 5.17187 22.7392 5.24503 23.0824 5.38718C23.4255 5.52932 23.7374 5.73766 24 6.0003C24.2626 6.26295 24.471 6.57475 24.6131 6.91791C24.7553 7.26107 24.8284 7.62887 24.8284 8.0003C24.8284 8.37174 24.7553 8.73953 24.6131 9.08269C24.471 9.42585 24.2626 9.73766 24 10.0003L10.5 23.5003L5 25.0003L6.5 19.5003L20 6.0003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_17620_34989_clip_path",
    transform: "translate(15 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDocumentUploadIcon);
export default __webpack_public_path__ + "static/media/edit-document-upload-icon.bb6e704385fe0806470f349509554654.svg";
export { ForwardRef as ReactComponent };